import styled from 'styled-components';

export const ToggleSettingContainer = styled.div`
    display: flex;
    justify-content: space-between;
`